package ru.villawonka.app.domain.model

data class UserSettingsDomain(
    val country: CountryDomain,
    val currency: CurrencyDomain,
    val language: LanguageDomain,
)